import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class SubscriptionCheckService {

    AUTH_API = `${environment.apiUrl}/auth/`;

    constructor(private http: HttpClient) {
    }
    async verify(): Promise<any> {
        const url = this.AUTH_API + 'verify';
        const payload = {};
        return await this.http.post<any>(url, payload).toPromise();
    }
}